// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__35wN0","title":"Card_title__Ip0in","center":"Card_center__3Cj99","header":"Card_header__21_95"};